<template>
  <header class="header">
    <div class="container-sm">
      <div class="row">
        <div class="col-md-12 col-lg-12">
          <nav class="navbar fixed-top">
            <div class="container">
              <div class="logoBox">
                <a
                  class="navbarBrand"
                  href="#/fr"
                  title="Postmedia Parcel Services"
                >
                  <img src="../../assets/logo.png" />
                </a>
              </div>
              <div class="navbar_menu">
                <div class="headerTextLink">
                  <a href="#/fr/track-your-shipment">SUIVEZ VOTRE ENVOI</a>
                </div>
                <div id="menu" @click="dropdownMenuToggle()">
                  <div class="menuLine1"></div>
                  <div class="menuLine2"></div>
                  <div class="menuLine3"></div>
                </div>
                <div class="headerTextLink langLink">
                  <a class="lang-lini" @click="goToEnglishVersion()">EN</a>
                </div>
                <div class="nav-page1" id="">
                  <ul>
                    <div class="menu-header-menu-container">
                      <ul id="menu-header-menu" class="menu">
                        <li
                          id="menu-item-225"
                          class="menu-item menu-item-type-post_type menu-item-object-page menu-item-225"
                        >
                          <a href="#/fr/track-your-shipment/"
                            >Suivez votre envoi</a
                          >
                        </li>
                        <li
                          id="menu-item-156"
                          class="menu-item menu-item-type-post_type menu-item-object-page menu-item-156"
                        >
                          <a href="#/fr/partners/">Solutions d’affaires</a>
                        </li>
                        <li
                          id="menu-item-154"
                          class="menu-item menu-item-type-post_type menu-item-object-page menu-item-154"
                        >
                          <a href="#/fr/couriers/">Agents de livraison</a>
                        </li>
                        <li
                          id="menu-item-156"
                          class="menu-item menu-item-type-post_type menu-item-object-page menu-item-154"
                        >
                          <a href="#/fr/careers/">Carrières</a>
                        </li>
                        <li
                          id="menu-item-157"
                          class="menu-item menu-item-type-post_type menu-item-object-page menu-item-157"
                        >
                          <a href="#/fr/support/">Soutien</a>
                        </li>
                      </ul>
                    </div>
                  </ul>
                </div>
                <div class="nav-page2"></div>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
/* eslint-disable */

export default {
  mounted() {
    let currentMenuClass = document.querySelector("#menu").classList;
    let menuLine1Class = document.querySelector(".menuLine1").classList;
    let menuLine2Class = document.querySelector(".menuLine2").classList;
    let menuLine3Class = document.querySelector(".menuLine3").classList;

    let navPage1Class = document.querySelector(".nav-page1").classList;
    let navPage2Class = document.querySelector(".nav-page2").classList;

    currentMenuClass.remove("rotate");
    menuLine1Class.remove("rotate1");
    menuLine2Class.remove("rotate2");
    menuLine3Class.remove("rotate2");

    navPage1Class.remove("transform");
    navPage2Class.remove("transform");
  },
  methods: {
    dropdownMenuToggle() {
      let currentMenuClass = document.querySelector("#menu").classList;
      let menuLine1Class = document.querySelector(".menuLine1").classList;
      let menuLine2Class = document.querySelector(".menuLine2").classList;
      let menuLine3Class = document.querySelector(".menuLine3").classList;

      let navPage1Class = document.querySelector(".nav-page1").classList;
      let navPage2Class = document.querySelector(".nav-page2").classList;

      if (currentMenuClass.contains("rotate")) {
        currentMenuClass.remove("rotate");
        menuLine1Class.remove("rotate1");
        menuLine2Class.remove("rotate2");
        menuLine3Class.remove("rotate2");

        navPage1Class.remove("transform");
        navPage2Class.remove("transform");
      } else if (!currentMenuClass.contains("rotate")) {
        currentMenuClass.add("rotate");
        menuLine1Class.add("rotate1");
        menuLine2Class.add("rotate2");
        menuLine3Class.add("rotate2");

        navPage1Class.add("transform");
        navPage2Class.add("transform");
      }
    },
    goToEnglishVersion() {
      let currentPagePath = this.$route.name;
      if (currentPagePath == "fr-home-page") {
        this.$router.push("/");
      } else {
        let path = "";
        if (currentPagePath == "fr-tracking-page")
          path = "/track-your-shipment";
        else if (currentPagePath == "fr-courier-page") path = "/couriers";
        else if (currentPagePath == 'fr-career-page') path = "/careers";
        else if (currentPagePath == "fr-partners-page") path = "/partners";
        else if (currentPagePath == "fr-support-page") path = "/support";
        else if (currentPagePath == "fr-about-page") path = "/about-postmedia";
        else if (currentPagePath == "fr-copyright-page") path = "/copyright";
        else if (currentPagePath == "fr-privacy-policy-page") path = "/google-apps-policy";
        else if (currentPagePath == "fr-email-opt-out") path = "/email-opt-out/:accountid";

        this.$router.push(path);
      }
    },
  },
  name: "page-header",
  components: {},
};
</script>
